import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken } from '../api.js';

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const { token } = await api.login(email, password);
      setToken(token);
      nav('/campaigns');
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'error');
    } finally { setBusy(false); }
  }

  return (
    <div className="login">
      <form onSubmit={submit}>
        <h1>SIP testing platform</h1>
        {err && <div className="err">{err}</div>}
        <label><span>Email</span>
          <input value={email} onChange={(e) => setEmail(e.target.value)} autoFocus /></label>
        <label><span>Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} /></label>
        <button className="primary" disabled={busy} style={{ width: '100%' }}>
          {busy ? 'Checking…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
